import React, { useState, useEffect } from 'react'
import MasterPage from 'components/MasterPage'
import { Card, Container, Row, Tabs, Tab } from 'react-bootstrap'
import { WidgetsOutlined } from '@material-ui/icons'

import TechnicalCall from './TechnicalCall'
import AccountContestation from './AccountContestation'
import ProviderRequestService from 'services/provider-request';

export default function(){
	const [providers, setProviders] = useState([]);

	useEffect(() => {
		ProviderRequestService.index({ params: { per_page: 20, page: 1 } })
			.then(({ data: response }) => {
				const { data } = response
				setProviders(data.map(({ id, name, url_image_logo }) => ({
					id, name, url_image_logo
				})))
			})
	}, [])

	return (<>
		<Container>
			<Row className="mt-4">
				<WidgetsOutlined className="icon-title" />
				<h5 className="title-dashboard">Suporte Pós Venda</h5>
			</Row>
			<Row>
				<Card.Body className="card-dashboard shadow bg-white rounded m-2 pt-4 pb-4 pr-4 pl-4 col-12">
					<Tabs defaultActiveKey="rc" id="technical_postsale">
						<Tab eventKey="rc" title="Chamado Técnico">
							<TechnicalCall providersList={providers} />
						</Tab>
						<Tab eventKey="ec" title="Contestação de Conta">
							<AccountContestation providersList={providers} />
						</Tab>
					</Tabs>
				</Card.Body>
			</Row>
		</Container>
	</>)
}